<div class="xray-items">
  <div class="text-danger heading">
    Missing Images
    <span *ngIf="viewMode === ViewMode.DRAFT" class="badge bg-danger">
      {{ mediaCategories.length - studyFiles.length }}
    </span>
  </div>

  <section
    *ngIf="viewMode === ViewMode.DRAFT; else viewXray"
    class="xray-item-section"
  >
    <div
      *ngFor="
        let mediaGroup of mediaGroups
          | filterActiveGroupsPipe
          | filterMatchedCategoriesPipe;
        trackBy: trackByGroup
      "
    >
      <div class="row xray-item-with-top-line">
        <div class="col-4 col-sm-4 text-left">
          <span class="position-left">LEFT</span>
        </div>
        <div class="col-4 col-sm-4 text-center">
          <span class="position-center"> {{ mediaGroup.name }}</span>
        </div>
        <div class="col-4 col-sm-4 text-end">
          <span class="position-right">RIGHT</span>
        </div>
      </div>
      <div class="row xray-item-with-vertical-line">
        <div class="col-lg-6">
          <div class="xray-data-left">
            <div class="row gutters-0">
              <div
                *ngFor="
                  let category of mediaGroup.mediaCategories
                    | withStudyFile : studyFiles : false : false : true;
                  trackBy: trackByCategory;
                  let $index = index
                "
                class="col-lg-4 col-md-6"
              >
                <app-xray-item
                  [studyFile]="category.studyFile"
                  [mediaCategory]="category.category"
                  [mediaCategories]="mediaCategories"
                  [mediaGroups]="mediaGroups"
                  [uploadDisabled]="
                    checkForCategoryIdUpload(category.category.id)
                  "
                  (changeCategoryClicked)="emitChangeMediaCategory($event)"
                  (uploadAdditionalClicked)="emitUploadAsAdditional($event)"
                  (deleteStudyFileClicked)="emitDeleteStudyFile($event)"
                  (uploadFiles)="uploadFiles($event)"
                  (viewImage)="viewImage($event)"
                ></app-xray-item>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="xray-data-right">
            <div class="row justify-content-end gutters-0">
              <div
                *ngFor="
                  let category of mediaGroup.mediaCategories
                    | withStudyFile : studyFiles : true : false : true;
                  trackBy: trackByCategory
                "
                class="col-lg-4 col-md-6"
              >
                <app-xray-item
                  [studyFile]="category.studyFile"
                  [mediaCategory]="category.category"
                  [mediaCategories]="mediaCategories"
                  [mediaGroups]="mediaGroups"
                  [uploadDisabled]="
                    checkForCategoryIdUpload(category.category.id)
                  "
                  (changeCategoryClicked)="emitChangeMediaCategory($event)"
                  (uploadAdditionalClicked)="emitUploadAsAdditional($event)"
                  (deleteStudyFileClicked)="emitDeleteStudyFile($event)"
                  (uploadFiles)="uploadFiles($event)"
                ></app-xray-item>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <ng-template #viewXray>
    <div class="xray-item-section extra-padding">
      <div class="row">
        <ng-container
          *ngFor="
            let studyFile of studyFiles | withCategoryPipe : mediaCategories;
            trackBy: trackByStudyFile
          "
        >
          <div class="col-md-2">
            <app-xray-item
              [studyFile]="studyFile"
              [mediaCategory]="studyFile.category"
              [mediaCategories]="mediaCategories"
              [mediaGroups]="mediaGroups"
              [viewMode]="viewMode"
              (changeCategoryClicked)="emitChangeMediaCategory($event)"
              (uploadAdditionalClicked)="emitUploadAsAdditional($event)"
              (deleteStudyFileClicked)="emitDeleteStudyFile($event)"
              (uploadFiles)="uploadFiles($event)"
              (updateStatus)="emitUpdateStatus($event)"
            ></app-xray-item>
          </div>
        </ng-container>

        <div class="col-md-2" *ngIf="viewMode === ViewMode.UPLOAD">
          <app-xray-item
            [studyFile]="null"
            [mediaCategory]="null"
            [mediaCategories]="mediaCategories"
            [mediaGroups]="mediaGroups"
            [viewMode]="ViewMode.DRAFT"
            [hideMatchedCategories]="true"
            (changeCategoryClicked)="emitChangeMediaCategory($event)"
            (uploadAdditionalClicked)="emitUploadAsAdditional($event)"
            (deleteStudyFileClicked)="emitDeleteStudyFile($event)"
            (uploadFiles)="uploadFiles($event)"
            (updateStatus)="emitUpdateStatus($event)"
          ></app-xray-item>
        </div>
        <!-- <ng-container
          *ngFor="let mediaGroup of mediaGroups | filterActiveGroupsPipe"
        >
          <div
            *ngFor="
              let category of mediaGroup.mediaCategories
                | withStudyFile : studyFiles : false : true
            "
            class="col-md-2"
          >
            <app-xray-item
              [studyFile]="category.studyFile"
              [mediaCategory]="category.category"
              [mediaCategories]="mediaCategories"
              [viewMode]="viewMode"
              (changeCategoryClicked)="emitChangeMediaCategory($event)"
              (uploadAdditionalClicked)="emitUploadAsAdditional($event)"
              (deleteStudyFileClicked)="emitDeleteStudyFile($event)"
              (uploadFiles)="uploadFiles($event)"
              (updateStatus)="emitUpdateStatus($event)"
            ></app-xray-item>
          </div> -->

        <!-- </ng-container> -->
      </div>
    </div>
  </ng-template>
</div>
